module.exports = __webpack_public_path__ + "img/a2.eb02fc5e.svg";